import React from "react";
import moment from "moment";
import Table from 'react-simpliest-table';

import ModulePanel from "../../ModulePanel";
import Modal from "../../Modal";
import QuestionDetail from "./QuestionDetail";

import surveyQuestions from "../../../screens/Survey/Questions/questions.json";


class QuestionsCount extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            showModal: false
        }
        this.handleState = this.handleState.bind(this);
    }

    handleState(data) {
        this.setState(data);
    }

    render(){
        const 
            { surveys, survey_questions } = this.props,
            { showModal, question = {} } = this.state;

        return (
            <ModulePanel title={["Respuestas recibidas"]}>
                <div className="table-responsive">
                    <table className="table mg-b-0">
                        <tbody>
                            {surveyQuestions.map((question) => {
                                return (
                                    <tr key={question.value}>
                                        <td>
                                            <button className="link" onClick={() => {
                                                this.handleState({
                                                    showModal: true,
                                                    question
                                                });
                                            }}>
                                                {question.text}
                                            </button>
                                        </td>
                                        <td>
                                            <button className="link" onClick={() => {
                                                this.handleState({
                                                    showModal: true,
                                                    question
                                                });
                                            }}>
                                                {((survey_questions[question.value] || 0)).toFixed(0)} respuestas
                                            </button>
                                        </td>
                                    </tr>
                                )
                            }, this)}
                        </tbody>
                    </table>
                </div>
        
                <Modal
                    title={question.text}
                    isVisible={showModal}
                    onClose={() => { this.handleState({ showModal: false }) }}>
                    <QuestionDetail question={question} surveys={surveys} handleState={this.props.handleState} />
                    
                    <Table
                        list={surveys}
                        filterFunction={record => `${record.name}`}
                        defaultMaxRecordPerPage={25}
                        defaultSorter={{ parameter: "startDate", order: "DESC" }}
                        labels={{
                            "all": "Mostrar todos",
                            "records_per_page": "Registros por página",
                            "showing": "Está mostrando",
                            "to": "a",
                            "of": "de",
                            "rows": "filas",
                            "no_data": "Tu listado está vacío",
                            "no_data_filtered": "Sin coincidencias filtradas",
                            "filter": "Pon tu filtro aquí"
                        }}
                        iterateFunction={(survey) => {
                            if (survey[question.value])
                            {
                                return (
                                    <tr key={survey.id}>
                                        <td>
                                            {Array.isArray(survey[question.value]) && (
                                                survey[question.value].join("; ")
                                            )}
                                            {!Array.isArray(survey[question.value]) && (
                                                survey[question.value]
                                            )}
                                        </td>
                                        <td> {moment.unix(survey.startDate).format("YYYY-MM-DD HH:mm:ss")} </td>
                                        <td>{survey.name}</td>
                                        <td className="text-right">{(survey.avg * 100 / 5).toFixed(0)}%</td>
                                        <td>
                                            <span onClick={() => {
                                                this.props.handleState({ individual: true, individualData: survey })
                                            }} className="btn btn-primary btn-sm">Ver éste feedback</span>
                                        </td>
                                    </tr>
                                )
                            }
                            return null;
                        }}
                        fields={[{
                            text: "Respuesta",
                            parameter: question.value
                        }, {
                            text: "Fecha",
                            parameter: "startDate"
                        }, {
                            text: "Nombre",
                            parameter: "name"
                        }, {
                            text: "Indice de satisfacción",
                            parameter: "avg"
                        }, {
                            text: "Feedback",
                            sortable: false
                        }]} />
                </Modal>
            </ModulePanel>
        )
    }

} 

export default QuestionsCount;